﻿export default class Poll {
  constructor (obj) {
    if (obj) {
      obj && Object.assign(this, obj)
      return
    }

    this.question = ''
    this.answers = []
    this.endDate = ''
    this.visible = ''
    this.visiblePollEnded = ''
    this.multipleAnswers = ''
  }
}
